<template>
  <div v-if="totalFeeCollection" class="head_fee_content py-4">
    <div class="head_fee_content_title">
      <h3>{{ title }}</h3>
      <span>{{ totalFeeCollection | price }}</span>
    </div>
    <div class="price_wrap">
      <div v-for="(collection, index) in Object.values(collections).sort((a, b) => a.rank - b.rank)" :key="index">
        <div v-if="collection.children" class="collection-title my-1">
          <h3>{{ index + 1 }}. {{ collection.title }}</h3>
        </div>
        <div
          v-for="(headFee, index) in Object.values(collection.children).sort((a, b) => a.rank - b.rank)"
          :key="index"
          class="ml-4"
        >
          <div v-if="headFee.amount" class="collection-title">
            <span>
              {{ get(headFee, 'metadata.shortName') || headFee.title }}
            </span>
            <span>{{ headFee.amount && headFee.amount | price }}</span>
          </div>
          <span v-if="headFee.amount && headFee.notes" class="note">{{ headFee.notes }}</span>
        </div>
      </div>
      <div v-if="totalCredit && totalCredit > 0">
        <div class="collection-title my-1">
          <h3>{{ Object.values(collections).length + 1 }}. Nạp quỹ xu</h3>
        </div>
        <div class="ml-4">
          <div class="collection-title">
            <span>Nạp xu</span>
            <span>{{ totalCredit | price }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
export default {
  computed: {
    totalFeeCollection() {
      let total = 0
      Object.values(this.collections).map(item => {
        let totalFeeChild = Object.values(item.children).reduce((acc, cur) => (acc += cur.amount), 0)
        total += totalFeeChild
      })
      return total + get(this, 'totalCredit', 0)
    }
  },
  props: {
    title: String,
    collections: {
      type: Object,
      default: () => ({})
    },
    totalCredit: Number
  },

  data() {
    return {
      get
    }
  }
}
</script>
<style lang="scss" scoped>
.head_fee_content {
  border-bottom: 1px solid #e0e0e0;
}

.collection-title {
  display: flex;
  justify-content: space-between;
}

.head_fee_content_title {
  font-weight: 500;
  font-size: 16px;
  // line-height: 24px;
  color: #fd6b6b !important;
  display: flex;
  justify-content: space-between;
}

.head_fee_content_title h3,
.head_fee_content_title span {
  color: #fd6b6b !important;
}

.note {
  display: block;
  max-width: 70% !important;
  color: #797979;
  margin-bottom: 6px;
  white-space: break-spaces;
}
</style>
